import React, { useEffect, useRef, useState } from "react";
import MolGrid from "../../../../../../components/molGrid/MolGrid";

import {
  manageXMLReportDataGridConfig,
} from "./manageXMLReportData.config";
import Buttons from "../../../../../../components/ui/button/Buttons";
import { useLazyGetManageXmlReportQuery, useUpdateXMLReportFieldsForMappingMutation } from "../../../../../../app/services/clientValuationAPI";
import ToastService from "../../../../../../services/toastService/ToastService";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import NoRecordFound from "../../../../../../components/molGrid/ui/noRecordFound/NoRecordFound";
import PropTypes from "prop-types";

const { create } = require('xmlbuilder2');

const headers = [
  { key: "displayName", label: "SchemaFieldName" },
  { key: "schemaFieldType", label: "SchemaFieldType" },
  { key: "valFieldValue", label: "Value" },
  { key: "valFieldOverride", label: "OverrideValue" }
];

const escapeCSV = (value) => {
  if (value === null || value === undefined) return "";
  const val = value.toString();
  if (val.includes(",") || val.includes('"') || val.includes("\n")) {
    return `"${val.replace(/"/g, '""')}"`;
  }
  return val;
};

const ManageXMLReportData = ({ XmlReportId, valId, templateId, isPrime }, props) => {
  const molGridRef = useRef();
  const [dataSource, setDataSource] = useState([]);
  const [isXSDTemplateModelOpen, setIsXSDTemplateModelOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState({})
  const [isloadingData, setIsloadingData] = useState(true)
  const [manageXmlReport, setManageXmlReport] = useState(manageXMLReportDataGridConfig)
  const editableFields = ['valFieldValue', 'valFieldOverride'];
  const [data, setData] = useState()
  const [getXMLReportFieldsForMapping, {
    isLoading: isXmlReportLoading,
    isFetching: isXmlReportFetching,
    isSuccess: isXmlReportSuccess,
    data: XmlSchemaReporttData,
  }] = useLazyGetManageXmlReportQuery();

  const [
    updateXmlMergeReport,
    {
      isLoading: isXmlMergeReportUpdating,
      isSuccess: isXmlMergeReportUpdated,
      data: xmlMergeReportUpdatedData,
    },
  ] = useUpdateXMLReportFieldsForMappingMutation();

  useEffect(() => {
    if (XmlReportId) {
      getXMLReportFieldsForMapping({ XmlReportId, valId, templateId })
    }
  }, [XmlReportId])

  const resetForm = () => {
    const form = { ...manageXMLReportDataGridConfig };
    form.initialState = {
      ...manageXMLReportDataGridConfig.initialState,
    }
    setManageXmlReport(form);
  };

  useEffect(() => {
    if (props.isEdit && props.initData) {
      const form = { ...manageXmlReport };
      form.initialState = {
        ...props.initData
      };
      setManageXmlReport(form);
    } else {
      resetForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isEdit, props.initData]);

  const handleFieldEditor = (options) => {
    const fieldName = options?.column?.props?.field;
    const isEditable = editableFields?.includes(fieldName) && options?.rowData?.schemaFieldType !== null;
  
    if (!isEditable) {
      return <>{options?.value}</>;
    }
  
    return (
      <InputText
        value={options?.value}
        onChange={(e) => options.editorCallback?.(e.target.value)}
        onKeyDown={(e) => e.stopPropagation()}
      />
    );
  };

  const onCellEditComplete = (e) => {
    const { newRowData, newValue, value, rowIndex, field } = e;

    if (newValue !== value) {
      handleSaveClick(newRowData)
  } else {
    console.log(`Field "${e?.field}" is not editable or schemaFieldType is null.`);
}
  };


const handleSaveClick = (updateData, rowIndexToUpdate) => {
  setDataSource(prevData =>prevData.map(item =>item.xmlSchemaField === updateData.xmlSchemaField ? {
    ...item,
    valFieldOverride: updateData.valFieldOverride,
    valFieldValue: updateData.valFieldValue,
  }
    : item
  ))
};

useEffect(() => {
  if (isXmlMergeReportUpdated && xmlMergeReportUpdatedData) {
    if (xmlMergeReportUpdatedData?.errorMessage?.includes("exist")) {
      ToastService.warning(xmlMergeReportUpdatedData.errorMessage);
    } else {
      ToastService.success(xmlMergeReportUpdatedData.errorMessage);
      props.onSuccess?.();
      getXMLReportFieldsForMapping({ XmlReportId, valId, templateId });
    }
  }
}, [isXmlMergeReportUpdated, xmlMergeReportUpdatedData]);

useEffect(() => {
  if (!isXmlReportFetching && isXmlReportSuccess) {
    function buildTree(XmlSchemaReporttData, parentId = 0) {
      return XmlSchemaReporttData.filter(item => item.xmlSchemaFieldParentID === parentId)
        .map(item => ({ ...item, children: buildTree(XmlSchemaReporttData, item.xmlSchemaField) }));
    }
    function flattenTreeWithPrefixes(nodes, level = 0) {
      let result = [];
      nodes.forEach(node => {
        const spacePrefix = '   '.repeat(level + 1);
        const prefix = level > 0 ? `${spacePrefix}|__` : '';
        result.push({
          ...node,
          displayName: `${prefix}${node.schemaFieldName}`
        });

        if (node.children && node.children.length > 0) {
          result = result.concat(flattenTreeWithPrefixes(node.children, level + 1));
        }
      });
      return result;
    }
    const tree = buildTree(XmlSchemaReporttData, 0);
    const flattened = flattenTreeWithPrefixes(tree);
    let updatedData = flattened.map(({ children, ...item }) => ({
      ...item,
    }));
    setDataSource(updatedData);
    setIsloadingData(isXmlReportFetching && XmlSchemaReporttData.length < 0 ? true : false);
    setData(XmlSchemaReporttData.length > 0)
  }
}, [isXmlReportFetching, isXmlReportSuccess, XmlSchemaReporttData]);

const handleCustomColumnButtonClick = (rowData) => {
  setSelectedRow(rowData)
  setIsXSDTemplateModelOpen(true);
};

// ==================================== Genrate XML File ================

/**  Builds a hierarchical tree from a flat list based on parent-child relationships.*/
const buildTreeFromFlatList = (list, parentId = 0) => {
  return list
    .filter(item => item.xmlSchemaFieldParentID === parentId)
    .map(item => ({
      ...item,
      children: buildTreeFromFlatList(list, item.xmlSchemaField),
    }));
};

const escapeForXML = (value) => {
  if (value === null || value === undefined) return "";
  return value.toString()
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
};

const convertTreeToXML = (nodes, indent = "  ") => {
  const buildXML = (nodeList, level = 1) => {
    return nodeList.map(node => {
      const {
        schemaFieldName,
        schemaFieldType,
        valFieldValue,
        valFieldOverride,
        children,
      } = node;

      const tagName = schemaFieldName || "Field";
      const attributes = [];
      if (schemaFieldType) attributes.push(`type="${escapeForXML(schemaFieldType)}"`);
      if (valFieldValue) attributes.push(`value="${escapeForXML(valFieldValue)}"`);
      if (valFieldOverride) attributes.push(`override="${escapeForXML(valFieldOverride)}"`);
      const indentStr = indent.repeat(level);
      const attrStr = attributes.length ? " " + attributes.join(" ") : "";
      if (children && children.length) {
        const innerXML = buildXML(children, level + 1).join("\n");
        return `${indentStr}<${tagName}${attrStr}>\n${innerXML}\n${indentStr}</${tagName}>`;
      } else {
        return `${indentStr}<${tagName}${attrStr} />`;
      }
    });
  };
  return buildXML(nodes).join("\n");
};

const GetRootNode = (field, ns) => {
  var nsPrefix = "";
  var obj = {
    "@xmlns:xref": "http://www.oracle.com/XSL/Transform/java/oracle.tip.xref.xpath.XRefXPathFunctions",
    "@xmlns:oraxsl": "http://www.oracle.com/XSL/Transform/java",
    "@xmlns:oracle-xsl-mapper": "http://www.oracle.com/xsl/mapper/schemas",
    "@xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
    "@xmlns:dvm": "http://www.oracle.com/XSL/Transform/java/oracle.tip.dvm.LookupValue",
    "@xmlns:mhdr": "http://www.oracle.com/XSL/Transform/java/oracle.tip.mediator.service.common.functions.MediatorExtnFunction",
    "@xmlns:socket": "http://www.oracle.com/XSL/Transform/java/oracle.tip.adapter.socket.ProtocolTranslator",
    "@xmlns": ns

  };
  if (nsPrefix) {
    obj["@xmlns:" + nsPrefix] = ns;
  }

  field.children.forEach((child) => {
    if (child.schemaFieldName) {
      var node = GetTreeNode(child, ns);
      if (node) {
        obj[child.schemaFieldName] = node;
      }

    }
  });

  var retObj = {};
  retObj[field.schemaFieldName] = obj;

  return retObj;
}

const GetTreeNode = (field, ns) => {
  var nsPrefix = "";
  var obj = {};

  if (field.isComplexType) {
    field.children.forEach((child) => {

      if (child.schemaFieldName) {
        var node = GetTreeNode(child, ns);
        if (node) {
          obj[child.schemaFieldName] = node;
        }
      }
    });

  }
  else {
    var valToWrite = field.valFieldValue || field.valFieldOverride || null;

    if (!valToWrite)
      return null;

    obj['#'] = valToWrite;
  }

  if (Object.keys(obj).length) {
    return obj;
  }
  return null;

}

const exportXMLFile = () => {
  const treeStructure = buildTreeFromFlatList(dataSource);
  const rootNode = GetRootNode(treeStructure[0]);
  const doc = create(rootNode);
  const xml = doc.end({ prettyPrint: true });

  const blob = new Blob([xml], { type: "application/xml" });
  const downloadLink = document.createElement("a");

  downloadLink.href = URL.createObjectURL(blob);
  downloadLink.download = "xml-data.xml";

  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);

  URL.revokeObjectURL(downloadLink.href);

  return;

};

const actionHandler = {
  EDIT: handleSaveClick,
};

return (
  <div className="xml-report-data-sec">
    <div className="row">
      {!isPrime ? <div className="col-12">
        <MolGrid
          ref={molGridRef}
          configuration={{
            ...manageXMLReportDataGridConfig,
            onRowDataUpdate: handleSaveClick,
          }}
          dataSource={dataSource}
          allowPagination={false}
          pagination={{
            totalCount: dataSource.length,
            pageSize: 20,
            currentPage: 1,
          }}
          onActionChange={actionHandler}
          onBeforeActionRender={(act, row) => {
            return !!row.schemaFieldType;
          }}
          isLoading={dataSource.length > 0 ? false : true}
        />
      </div> :
        <div className="prime-table-sec xml-report-field">
        <div className="card">
          {data > 0 ? 
          <DataTable
            value={dataSource}
            stripedRows
              scrollable
              scrollHeight="400px"
              virtualScrollerOptions={{ itemSize: 20 }}
            editMode="cell"
            tableStyle={{ minWidth: '50rem' }}
            metaKeySelection={true}
          >
            {manageXMLReportDataGridConfig?.columns?.map((item, index) => {
              const isFieldEditable = editableFields.includes(item.fieldName);

              return (
                <Column
                  key={index}
                  field={item.fieldName}
                  header={item.name}
                  style={{ width: '20%' }}
                  editor={(options) => handleFieldEditor(options)}
                  onCellEditComplete={(e) => onCellEditComplete(e)}
                />
              );
            })}
          </DataTable>
          : <NoRecordFound/>
}
        </div>
        </div>
      }
      <div className="col-12">
        <div className="d-flex justify-content-end mt-3">
          <Buttons
            buttonText="Generate XML"
            buttonTypeClassName="btn blue-btn"
            onClick={exportXMLFile}
          />
        </div>
      </div>

    </div>
  </div>
);
};

ManageXMLReportData.propTypes = {
  XmlReportId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  templateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isPrime: PropTypes.bool,
  isEdit: PropTypes.bool,
  initData: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default ManageXMLReportData;
